var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "24px",
    height: "24px",
    viewBox: "0 0 0.72 0.72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.63 0.06H0.09a0.03 0.03 0 0 0 -0.03 0.03v0.54a0.03 0.03 0 0 0 0.03 0.03h0.54a0.03 0.03 0 0 0 0.03 -0.03V0.09a0.03 0.03 0 0 0 -0.03 -0.03m-0.098 0.262a0.12 0.12 0 0 1 -0.01 0.001A0.107 0.107 0 0 1 0.432 0.274v0.165a0.122 0.122 0 1 1 -0.122 -0.122c0.003 0 0.005 0 0.008 0v0.06a0.062 0.062 0 1 0 -0.008 0.124 0.064 0.064 0 0 0 0.065 -0.061l0.001 -0.28h0.057A0.107 0.107 0 0 0 0.532 0.255Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.e18dc164458f46b2faf897f05a6f74a1.svg";
export { ForwardRef as ReactComponent };